import React, { memo } from 'react';

import Heading from '@atlaskit/heading';

import { AnimatedContainer } from './animated-container';

export const AnimatedHeader = memo(
	({
		children,
		isStreaming = false,
	}: {
		children: React.ReactNode;
		isStreaming?: boolean;
	}) => {
		return (
			<AnimatedContainer isStreaming={isStreaming}>
				<Heading size="xsmall" as="h2">
					{children}
				</Heading>
			</AnimatedContainer>
		);
	},
);

AnimatedHeader.displayName = 'AnimatedHeader';
